import LottieAnimation from 'lottie-web-vue'

export default {
  name: 'ChatFiltersNewAnimation',
  components: { LottieAnimation }
}
